import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { BASIC } from '../shared/urls';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const apiUrl = new URL(BASIC.API, location.origin);
    const requestUrl = new URL(request.url, location.origin);
    if (requestUrl.origin !== apiUrl.origin ||
        !requestUrl.pathname.startsWith(apiUrl.pathname) ||
        request.headers.has('Authorization')) {
      return next.handle(request);
    }

    let currentUser: unknown;
    try {
      currentUser = JSON.parse(sessionStorage.getItem('currentJwtToken') ?? 'null');
    } catch (error) {
      if (!(error instanceof SyntaxError)) throw error;
      return next.handle(request);
    }
    if (typeof currentUser === 'object' && currentUser !== null &&
        'id_token' in currentUser && typeof currentUser.id_token === 'string' &&
        currentUser.id_token.length > 0) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.id_token}`,
          'Cache-Control':
            'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
          Pragma: 'no-cache',
          Expires: '0',
        },
      });
    }

    return next.handle(request);
  }
}
